// 获取当前时间
export function getNowTime(fmt = "yyyy-MM-dd HH:mm:ss") {
  const myDate = new Date(); // 获取系统当前时间
  return dateFtt(myDate, fmt);
}
// 时间格式化处理
export function dateFtt(date, fmt) {
  let o = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "H+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
}
export function getWeekTime() {
  const now = new Date();
  const nowTime = now.getTime();
  const day = now.getDay();
  const oneDayLong = 24 * 60 * 60 * 1000;
  const MondayTime = nowTime - (day - 1) * oneDayLong;
  // const SundayTime = nowTime + (7 - day) * oneDayLong
  const monday = new Date(MondayTime);
  let strDate = monday.getDate();
  // const sunday = new Date(SundayTime)
  // const endDate = sunday.getDate()
  const year = now.getFullYear();
  let month = now.getMonth() + 1;
  if (month >= 1 && month <= 9) month = "0" + month;
  if (strDate >= 0 && strDate <= 9) strDate = "0" + strDate;
  const seperator1 = "-";
  // 周一
  // const startTime = year + seperator1 + month + seperator1 + strDate
  // 周天
  //  endTime = year + seperator1 + month + seperator1 + endDate;
  return year + seperator1 + month + seperator1 + strDate;
}
